import {
  administrationTranslation,
  AdministrationTranslation,
} from '@/assets/locales/views/administration/administration.translation.pl.ts';
import {
  calendarTranslation,
  CalendarTranslation,
} from '@/assets/locales/views/calendar/calendar.translation.pl.ts';
import {
  carsViewTranslation,
  CarsViewTranslation,
} from '@/assets/locales/views/cars/cars.translation.pl.ts';
import {
  catalogTranslation,
  CatalogTranslation,
} from '@/assets/locales/views/catalog/catalog.translation.pl.ts';
import {
  chatsViewTranslation,
  ChatsViewTranslation,
} from '@/assets/locales/views/chats/chatsView.translation.pl.ts';
import {
  contactsTranslation,
  ContactsTranslation,
} from '@/assets/locales/views/contacts/contacts.translation.pl.ts';
import {
  contactsCreateTranslation,
  ContactsCreateTranslation,
} from '@/assets/locales/views/contactsCreate/contactsCreate.translation.pl.ts';
import {
  contactsDetailsTranslation,
  ContactsDetailsTranslation,
} from '@/assets/locales/views/contactsDetails/contactsDetails.translation.pl.ts';
import {
  customerDetailsTranslation,
  CustomerDetailsTranslation,
} from '@/assets/locales/views/customerDetails/customerDetails.translation.pl.ts';
import {
  customersViewTranslation,
  CustomersViewTranslation,
} from '@/assets/locales/views/customers/customers.view.translation.pl.ts';
import {
  customersBusinessCreateTranslation,
  CustomersBusinessCreateTranslation,
} from '@/assets/locales/views/customersBusinessCreate/customersBusinessCreate.translation.pl.ts';
import {
  customersForeignCreateTranslation,
  CustomersForeignCreateTranslation,
} from '@/assets/locales/views/customersForeignCreate/customersForeignCreate.translation.pl.ts';
import {
  customersIndividualCreateTranslation,
  CustomersIndividualCreateTranslation,
} from '@/assets/locales/views/customersIndividualCreate/customersIndividualCreate.translation.pl.ts';
import {
  dashboardViewTranslation,
  DashboardViewTranslation,
} from '@/assets/locales/views/dashboard/dashboardView.translation.pl.ts';
import {
  dictionariesViewsTranslation,
  DictionariesViewTranslation,
} from '@/assets/locales/views/dictionaries/dictionaries.translation.pl.ts';
import {
  dishesTranslation,
  DishesTranslation,
} from '@/assets/locales/views/dishes/dishes.translation.pl.ts';
import {
  dishesImportTranslation,
  DishesImportTranslation,
} from '@/assets/locales/views/dishesImport/dishesImport.translation.pl.ts';
import {
  emailsViewTranslation,
  EmailsViewTranslation,
} from '@/assets/locales/views/emails/emailsView.translation.pl.ts';
import {
  emergencyContactsTranslation,
  EmergencyContactsTranslation,
} from '@/assets/locales/views/emergencyContacts/emergencyContacts.translation.pl.ts';
import { hrTranslation, HrTranslation } from '@/assets/locales/views/hr/hr.translation.pl.ts';
import {
  offerElementsTranslation,
  OfferElementsTranslation,
} from '@/assets/locales/views/offerElements/offerElements.translation.pl.ts';
import {
  offerGroupDefinitionsTranslation,
  OfferGroupDefinitionsTranslation,
} from '@/assets/locales/views/offerGroupDefinitions/offerGroupDefinitions.translation.pl.ts';
import {
  offersTranslation,
  OffersTranslation,
} from '@/assets/locales/views/offers/offers.translation.pl.ts';
import {
  offersBrowseTranslation,
  OffersBrowseTranslation,
} from '@/assets/locales/views/offersBrowse/offersBrowse.translation.pl.ts';
import {
  pptxImportTranslation,
  PptxImportTranslation,
} from '@/assets/locales/views/pptxImport/pptxImport.translation.pl.ts';
import {
  ProcessTranslation,
  processTranslation,
} from '@/assets/locales/views/processes/process.translation.pl.ts';
import {
  processesTranslation,
  ProcessesTranslation,
} from '@/assets/locales/views/processes/processes.translation.pl.ts';
import {
  ProcessesCreateTranslation,
  processesCreateTranslation,
} from '@/assets/locales/views/processesCreate/processesCreate.translation.pl.ts';
import {
  processesDetailsTranslation,
  ProcessesDetailsTranslation,
} from '@/assets/locales/views/processesDetails/processesDetails.translation.pl.ts';
import {
  ProcessesUpdateTranslation,
  processUpdateTranslation,
} from '@/assets/locales/views/processesUpdate/processesUpdate.translation.pl.ts';
import {
  reportsTranslation,
  ReportsTranslation,
} from '@/assets/locales/views/reports/reports.translation.pl.ts';
import {
  settlementsTranslation,
  SettlementsTranslation,
} from '@/assets/locales/views/settlements/settlements.translation.pl.ts';
import {
  suppliersTranslation,
  SuppliersTranslation,
} from '@/assets/locales/views/suppliers/suppliers.translation.pl.ts';
import {
  tasksTranslations,
  TasksTranslations,
} from '@/assets/locales/views/tasks/tasks.translations.pl.ts';
import {
  usersTranslation,
  UsersTranslation,
} from '@/assets/locales/views/users/users.translation.pl.ts';
import {
  utilViewsTranslation,
  UtilViewsTranslation,
} from '@/assets/locales/views/util/utilViews.translation.pl.ts';

import { statisticsTranslation } from './statistics.translation.pl';

export type ViewsTranslation = {
  administration: AdministrationTranslation;
  calendar: CalendarTranslation;
  cars: CarsViewTranslation;
  catalog: CatalogTranslation;
  chats: ChatsViewTranslation;
  contacts: ContactsTranslation;
  contactsCreate: ContactsCreateTranslation;
  contactsDetails: ContactsDetailsTranslation;
  customerDetails: CustomerDetailsTranslation;
  customers: CustomersViewTranslation;
  customersBusinessCreate: CustomersBusinessCreateTranslation;
  customersForeignCreate: CustomersForeignCreateTranslation;
  customersIndividualCreate: CustomersIndividualCreateTranslation;
  dashboard: DashboardViewTranslation;
  dictionaries: DictionariesViewTranslation;
  dishes: DishesTranslation;
  dishesImport: DishesImportTranslation;
  emails: EmailsViewTranslation;
  emergencyContacts: EmergencyContactsTranslation;
  hr: HrTranslation;
  offerElements: OfferElementsTranslation;
  offerGroupDefinitions: OfferGroupDefinitionsTranslation;
  offers: OffersTranslation;
  offersBrowse: OffersBrowseTranslation;
  pptxImport: PptxImportTranslation;
  process: ProcessTranslation;
  processes: ProcessesTranslation;
  processesCreate: ProcessesCreateTranslation;
  processesDetails: ProcessesDetailsTranslation;
  processesUpdate: ProcessesUpdateTranslation;
  reports: ReportsTranslation;
  settlements: SettlementsTranslation;
  statistics: typeof statisticsTranslation;
  suppliers: SuppliersTranslation;
  tasks: TasksTranslations;
  users: UsersTranslation;
  util: UtilViewsTranslation;
};

export const viewsTranslation: ViewsTranslation = {
  administration: administrationTranslation,
  calendar: calendarTranslation,
  cars: carsViewTranslation,
  catalog: catalogTranslation,
  chats: chatsViewTranslation,
  contacts: contactsTranslation,
  contactsCreate: contactsCreateTranslation,
  contactsDetails: contactsDetailsTranslation,
  customerDetails: customerDetailsTranslation,
  customers: customersViewTranslation,
  customersBusinessCreate: customersBusinessCreateTranslation,
  customersForeignCreate: customersForeignCreateTranslation,
  customersIndividualCreate: customersIndividualCreateTranslation,
  dashboard: dashboardViewTranslation,
  dictionaries: dictionariesViewsTranslation,
  dishes: dishesTranslation,
  dishesImport: dishesImportTranslation,
  emails: emailsViewTranslation,
  emergencyContacts: emergencyContactsTranslation,
  hr: hrTranslation,
  offerElements: offerElementsTranslation,
  offerGroupDefinitions: offerGroupDefinitionsTranslation,
  offers: offersTranslation,
  offersBrowse: offersBrowseTranslation,
  pptxImport: pptxImportTranslation,
  process: processTranslation,
  processes: processesTranslation,
  processesCreate: processesCreateTranslation,
  processesDetails: processesDetailsTranslation,
  processesUpdate: processUpdateTranslation,
  reports: reportsTranslation,
  settlements: settlementsTranslation,
  statistics: statisticsTranslation,
  suppliers: suppliersTranslation,
  tasks: tasksTranslations,
  users: usersTranslation,
  util: utilViewsTranslation,
};
